export const theme = {
  primary: "#0b0c10",
  textColor: "#ff8c42",
};
